<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/equipment/equipment-list' }">设备管理</el-breadcrumb-item>
          <el-breadcrumb-item >使用单位详情</el-breadcrumb-item>
        </el-breadcrumb>
    </div>

      <!-- 1.医院信息 -->
      <div class="equipment-message">
        <!-- <dv-border-box-12 > -->
          <div class="base-message">
            <div class="header-common">
              <div class="header-common-left">
                <div class="title">使用单位信息</div>
              </div>
            </div>
            <div>
                <el-descriptions
                :column="2"
                border
                :contentStyle="contentStyle"
                :labelStyle='labelStyle'>
                  <el-descriptions-item label="所在地区" >
                    <span >{{area.provinceName}}/{{area.cityName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="使用单位" >
                    <span >{{hospitalName}}</span>
                  </el-descriptions-item>
                  <el-descriptions-item label="耗材告警阈值" >
                    <span >{{stockThreshold}}</span>
                    <button class="stock" v-if="showConsAlert==true" @click="handleStockThreshold">修改</button>
                  </el-descriptions-item>
                  <!-- <el-descriptions-item label="耗材剩余" >
                    <span >{{tableConsData.length}}</span>
                    <el-tooltip class="item" effect="dark" :content="stockThreshold" placement="top-start"  v-if="showConsAlert==true" >
                      <el-button style="margin-left: 50px;background-color: orange;color: #fff;border: 0px;" size="mini" @click="handleStockThreshold">告警阈值</el-button>
                    </el-tooltip>
                  </el-descriptions-item>
                  <el-descriptions-item label="耗材使用" >
                    <span >{{tableConsData.length}}</span>
                  </el-descriptions-item> -->
                </el-descriptions>
            </div>
          </div>
        <!-- </dv-border-box-12> -->
      </div>

      <!-- 2. 设备列表 -->
      <div class="equip-table-content" v-if="showEquipList==true">
        <div class="header-common">
          <div class="header-common-left">
            <div class="title">设备列表</div>
          </div>
        </div>
        <div class="table-list">
          <el-table
            v-loading='loading1'
            border
            :cell-style="tableCellStyle"
            :header-cell-style="tableHeaderCellStyle"
            :data="tableEquipmentData"
            >
            <el-table-column
              type="index"
              label="序号"
              >
            </el-table-column>
            <!-- <el-table-column
              prop="shipDate"
              label="出库日期"
              >
            </el-table-column> -->
            <el-table-column
              prop="typeName"
              label="产品名称">
            </el-table-column>
            <el-table-column
              prop="typeModel"
              label="规格型号">
            </el-table-column>
            <el-table-column
              prop="udi"
              label="UDI"
              :width="400"
              >
            </el-table-column>
            <el-table-column
              prop="status"
              label="当前状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status==1">正常</span>
                <span v-if="scope.row.status==2">关机</span>
                <span v-if="scope.row.status==3">故障</span>
                <span v-if="scope.row.status==4">手术中</span>
              </template>
            </el-table-column>
            <el-table-column
              width="220"
              label="操作">
              <template slot-scope="scope">
                <router-link
                  class="action-button-base"
                  :to="{path:'/manage/equipment/equipment-details',query:{id:scope.row.id,}}"
                >
                  使用记录
                </router-link>
                <router-link
                  class="action-button-base"
                  v-if="showEquipMaintain==true"
                  :to="{path:'/manage/equipment/equipment-details',query:{id:scope.row.id,}}"
                >
                  维护记录
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>

      <!-- 2.耗材库存及使用记录 -->
     <div class="tabs-content" v-if="showConsInventory==true || showConsUsed==true">
          <div class="condition">
            <div style="">
              <el-tabs
              type="border-card"
              style="background-color: transparent;border: 1px solid #1A3F81;border-radius: 12px;"
              v-model="activeName"
              @tab-click="handleClick"
              >
                  <el-tab-pane style="background-color: transparent;" name="consUnused" v-if="showConsInventory==true">
                    <span slot="label"><i class="el-icon-date"></i> 耗材剩余记录</span>
                    <div class="table-content">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">耗材剩余记录</div>
                        </div>
                        <div class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportUnusedTable"
                            type="text"
                            >
                            导出
                          </el-button>
                        </div>
                      </div>
                      <div class="table-list">
                        <el-table
                          v-loading='loading2'
                          border
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          :data="tableConsData.filter(data => !search1 || data.shipDate.toLowerCase().includes(search1.toLowerCase()) || data.type.toLowerCase().includes(search1.toLowerCase()) || data.udi.toLowerCase().includes(search1.toLowerCase()))"

                          >

                          <el-table-column
                            type="index"
                            label="序号"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="shipDate"
                            label="出库日期">
                          </el-table-column>
                          <el-table-column
                            prop="typeName"
                            label="产品名称">
                          </el-table-column>
                          <el-table-column
                            prop="typeModel"
                            label="规格型号"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="udi"
                            label="UDI">
                          </el-table-column>
                          <el-table-column
                            label="状态"
                            >
                            未使用
                            <template slot="header" slot-scope="scope">
                              <el-input
                                id="search1"
                                v-model="search1"
                                size="mini"
                                placeholder="输入关键字搜索"/>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>

                    </div>
                  </el-tab-pane>
                  <el-tab-pane style="background-color: transparent;" name="consUsed" v-if="showConsUsed==true">
                    <span slot="label"><i class="el-icon-date"></i> 耗材使用记录</span>
                    <div class="table-content">
                      <div class="header-common">
                        <div class="header-common-left">
                          <div class="title">耗材使用记录</div>
                        </div>
                        <div class="header-common-right">
                          <el-button
                            class="right-button-export"
                            @click="exportUsedTable"
                            type="text"
                            >
                            导出
                          </el-button>
                        </div>
                      </div>
                      <div class="table-list">
                        <el-table
                          v-loading='loading2'
                          border
                          :cell-style="tableCellStyle"
                          :header-cell-style="tableHeaderCellStyle"
                          :max-height="tableHeight"
                          :data="tableConsData.filter(data => !search2 || data.useDate.toLowerCase().includes(search2.toLowerCase()) || data.type.toLowerCase().includes(search2.toLowerCase()) || data.udi.toLowerCase().includes(search2.toLowerCase()))"

                          >

                          <el-table-column
                            type="index"
                            label="序号"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="useDate"
                            label="使用日期"
                            >
                          </el-table-column>
                          <el-table-column
                            prop="typeName"
                            label="产品名称">
                          </el-table-column>
                            <el-table-column
                              prop="typeModel"
                              label="规格型号">
                            </el-table-column>
                            <el-table-column
                              prop="udi"
                              label="UDI">
                            </el-table-column>
                            <el-table-column
                              label="状态"
                              >已使用
                              <template slot="header" slot-scope="scope">
                                <el-input
                                  id="search2"
                                  v-model="search2"
                                  size="mini"
                                  placeholder="输入关键字搜索"/>
                              </template>
                            </el-table-column>
                        </el-table>
                      </div>

                    </div>
                  </el-tab-pane>
                </el-tabs>
            </div>
          </div>
      </div>

  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'
  import { permissionCheckUtil} from "../../../utils/permission.js"
  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '108px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          // 'line-height': '50px',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },
        showConsAlert:false,
        showConsUsed:false,
        showConsInventory:false,
        showEquipMaintain:false,
        showEquipList:false,

        search1:'',
        search2:'',
        tableHeight:0,

        showAction:false,
        activeName:'consUnused',

        //医院信息
        id:'',//医院ID
        area:{
          provinceCode:'',
          provinceName:'',
          cityCode:'',
          cityName:'',
        },
        hospitalName:'',
        stockThreshold:0,

        //设备列表
        tableEquipmentData:[],
        loading1:false,
        loading2:false,

        tableConsData:[],//耗材记录
      }
    },
    methods: {
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;text-align:left;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:left;font-size: 15px;font-weight: 400;color: #00FFFF;'
      },
      handleClick(tab){
        this.search1 = ''
        this.search2 = ''
        if(tab.name=="consUnused"){
            this.getConsInventory()
        } else if(tab.name=="consUsed"){
            this.getConsUsed()
        }
      },
      //医院信息
      getHospitalMessage(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/brief';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              // 1.医院信息
              this.area.provinceCode = obj.data.provinceCode;
              this.area.cityCode = obj.data.cityCode;
              this.hospitalName = obj.data.name;
              this.stockThreshold = obj.data.stockThreshold;

              areaSingleConversionUtil.codeToName(this.area)
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getEquipmentMessage(){
        this.loading1 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/equipment/detail';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading1 = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.equipments){
                this.tableEquipmentData = obj.data.equipments;
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading1 = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsUsed(){
        this.loading2 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/consumable/used';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading2 = false
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              //4.耗材使用记录
              if(obj.data.consumables){
                this.tableConsData = obj.data.consumables
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading2 = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsInventory(){
        this.loading2 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/consumable/unused';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading2 = false
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              //3.医院耗材库存记录
              if(obj.data.consumables){
                this.tableConsData = obj.data.consumables;
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading2 = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      exportUnusedTable(){
        var tableHeader = [['序号','出库日期','产品名称','规格型号','UDI','状态']];
        var dataList = [];
        this.tableConsData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.shipDate,
            item.typeName,
            item.typeModel,
            item.udi,
            '未使用'
          ]);
        });

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(this.hospitalName+'-耗材剩余记录',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }

      },
      exportUsedTable(){
        var tableHeader = [['序号','使用日期','产品名称','规格型号','UDI','状态']];
        var dataList = [];
        this.tableConsData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.useDate,
            item.typeName,
            item.typeModel,
            item.udi,
            '已使用'
          ]);
        });
        
        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(this.hospitalName+'-耗材使用记录',tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      handleStockThreshold(){
        this.$prompt('请输入告警阈值', '修改耗材告警阈值', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.handleStockThresholdAction(value);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      // 设置阈值
      handleStockThresholdAction(value){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/update';
        const data = {"id":this.id,"threshold":value} //医院ID

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.stockThreshold = value;
              this.$message.success('修改成功');
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      judgePermissions(){
          let per1 = permissionCheckUtil.findName("consumable:alert");
          let per2 = permissionCheckUtil.findName("consumable:readUsed");
          let per3 = permissionCheckUtil.findName("consumable:readInventory");
          let per4 = permissionCheckUtil.findName("equipment:maintain");
          let per5 = permissionCheckUtil.findName("equipment:read");

          if(per1==true){
            this.showConsAlert = true;
          }

          if(per2==true){
            this.showConsUsed = true;
          }

          if(per3==true){
            this.showConsInventory = true;
          }

          if(per4==true){
            this.showEquipMaintain = true;
          }

          if(per5==true){
            this.showEquipList=true
          }

      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-680 < 300 ? 300 : window.innerHeight-680;
        })
      },
    },
    created() {

      this.judgePermissions();

      this.id = this.$route.query.id;


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)

    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()

      this.getHospitalMessage()

      if(this.showEquipList==true){
        this.getEquipmentMessage()
      }

      if(this.showConsInventory==true){
        this.getConsInventory()
        this.activeName = 'consUnused'
      }else{
        if(this.showConsUsed==true){
          this.getConsUsed()
          this.activeName = 'consUsed'
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
.container{
  margin-top: $header-height;

  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .equipment-message{

    .stock{
      margin-left:30px;
      width: 60px;
      height: 36px;
      background: #FAFAFA;
      border: 1px solid rgba(255, 132, 0, 0.84);
      border-radius: 20px;
      // background-color: #B26100;
      // color: #FFCC00;
      background-color: #D3CC15;
      color: black;
      // rgba(255, 132, 0, 0.84);
      font-size: 14px;
      font-weight: 400;

      display: inline-block;
      line-height: 36px;
      text-align: center;
      text-decoration: none;
    }

    .base-message{
      // padding: 6px 2px 10px 6px;
    }
  }

  .equip-table-content{
    margin-top: $main-padding;
    .table-list{
      .action-button-base{
        width: 89px;
        height: 31px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        display: inline-block;
        line-height: 31px;
        text-align: center;
        text-decoration: none;
      }
    }
  }

  .tabs-content{

    margin-top: $main-padding;

    .table-content{

      .table-list{

      }
    }

  }



  // 公共头部样式
  .header-common{
    height: 45px;
    // margin-right:4px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-common-left{
      font-size: 20px;
      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
    }

    .header-common-right{
      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }



    }
  }
}

  .el-radio__input.is-checked .el-radio__label{
    color: #B26100 !important
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #B26100 !important;
    border-color: #B26100 !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/manage/equipment/equipment-hospital-one.vue